import script from "./SuccessPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuccessPage.vue?vue&type=script&lang=ts&setup=true"

import "./SuccessPage.vue?vue&type=style&index=0&id=f40c6da2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f40c6da2"]])

export default __exports__